/** SSE payload from info-api after GenericBroadcast (data = payload only). Must not use key `gameType` (legacy results flow). */

export const STREAMING_CAMBIO_EVENT_COMMAND_ON = 'status-streaming-on';
export const STREAMING_CAMBIO_EVENT_COMMAND_OFF = 'status-streaming-off';
export const STREAMING_CAMBIO_EVENT_COMMAND_PLAQUETAS = 'show-plaquetas';

/** Prefer ON/OFF; kept so older broadcasts still refresh the catalog */
export const STREAMING_CAMBIO_EVENT_COMMAND_LEGACY = 'status-streaming';

const STREAMING_CAMBIO_COMMANDS = new Set<string>([
  STREAMING_CAMBIO_EVENT_COMMAND_ON,
  STREAMING_CAMBIO_EVENT_COMMAND_OFF,
  STREAMING_CAMBIO_EVENT_COMMAND_PLAQUETAS,
  STREAMING_CAMBIO_EVENT_COMMAND_LEGACY,
]);

export type StreamingCambioEventCommand =
  | typeof STREAMING_CAMBIO_EVENT_COMMAND_ON
  | typeof STREAMING_CAMBIO_EVENT_COMMAND_OFF
  | typeof STREAMING_CAMBIO_EVENT_COMMAND_PLAQUETAS
  | typeof STREAMING_CAMBIO_EVENT_COMMAND_LEGACY;

function normalizeGameId(value: unknown): number | null {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }
  if (typeof value === 'string' && value.trim() !== '') {
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
  }
  return null;
}

export function isStreamingCambioEventPayload(data: unknown): data is { gameId: number; command: string } {
  if (data === null || typeof data !== 'object') {
    return false;
  }
  const o = data as Record<string, unknown>;
  const gameId = normalizeGameId(o['gameId'] ?? o['gameID']);
  const command = o['command'];
  if (gameId === null || typeof command !== 'string') {
    return false;
  }
  return STREAMING_CAMBIO_COMMANDS.has(command);
}
